module.exports = __webpack_public_path__ + "img/icon9.d3e830c5.svg";